import { sayHello } from './modules/myotherfile.js';
import Header from './modules/header.js';
import Timeline from './modules/timeline.js';
import { Commerce } from './modules/commerce.js';

document.addEventListener('DOMContentLoaded', () => {
  new Header(); 
  new Timeline(); 
  Commerce();
});


     